import api from '../../api/api_resource'
import collect from 'collect.js'
import moment from "moment";
import axios from "axios";
import ldb from '../../thirdparty/localdata'
import router from '../../router'
import {objToUrl} from "../../util/common";

const saveState = (state) => {
    state.isFromSessionStorage = true
    const newState = JSON.parse(JSON.stringify(state))
    newState.all = []
    newState.ids = []
    window.sessionStorage.setItem('user_bids_state', JSON.stringify({ state: newState, expiration: Date.now() + 8 * 3600 * 1000 }))
}

let userBidsState = window.sessionStorage.getItem('user_bids_state')
let state
if (userBidsState) {
    try {
        state = JSON.parse(userBidsState)
    } catch (e) {
        state = null
    }
}
if (state && state.state && state.expiration && state.expiration > Date.now()) {
    state = state.state
} else {
    state = null
}
if (!state) {
    state = {
        ids: [],
        all: [],
        byVehicle: [],
        current_page: 1,
        per_page: 500,
        from: 1,
        to: 25,
        last_page: null,
        total: null,
        vehicleChecked: null,
        bidChecked: null,
        filteredUsers: null,
        includeCustomers: true,
        includeCompanyStock: false,
        includeRep: true,
        repFilter: null,
        searchChassis: '',
        searchLot: '',
        selected_vehicles: [],
        dateOption: moment().format('YYYY-MM-DD'),
        customDate: '',
        sortOrderBy: 'created_at',
        viewType: 'list',
        perRow: 5,
    }
}

// getters
const getters = {
    all: (state, getters, rootState) => {
        return state.all;
    },
    ids: (state, getters, rootState) => {
        return state.ids;
    },
    getCurrentPage: (state, getters, rootState) => {
        return state.current_page;
    },
    getSelectedVehicles: state => state.selected_vehicles,
    getVehicleChecked: state => state.vehicleChecked,
    getBidChecked: state => state.bidChecked,
    getFilteredUsers: state => state.filteredUsers,
    getIncludeCustomers: state => state.includeCustomers,
    getIncludeCompanyStock: state => state.includeCompanyStock,
    getIncludeRep: state => state.includeRep,
    getRepFilter: state => state.repFilter,
    getSearchChassis: state => state.searchChassis,
    getSearchLot: state => state.searchLot,
    getDateOption: state => state.dateOption,
    getCustomDate: state => state.customDate,
    getSortOrderBy: state => state.sortOrderBy,
    getViewType: state => state.viewType,
    getPerRow: state => state.perRow
};

// actions
const actions = {
    getBids({ commit, state }, {params, cancelToken} = {cancelToken: axios.CancelToken.source(), params: {}}) {
        return new Promise((success, error) => {
            ldb.get('user_bids', ldb_user_bids => {
                const arg_string = objToUrl(params)
                const getFreshData = () => {

                    params.sort_asc = params.sort_asc?1:0;
                    const search_args = Object.assign({
                        page: state.current_page,
                        per_page: state.per_page
                    }, params);
                    api.index('user-bid', search_args, cancelToken).then(bidlist => {
                        bidlist.state_key = window.history && window.history.state && window.history.state.key ? window.history.state.key : null
                        bidlist.arg_string = arg_string
                        commit('setBids', bidlist);
                        success(bidlist);
                        ldb.set('user_bids', bidlist, () => {console.log('set user_bids ldb')})
                    }).catch(error => {
                        console.log('error ' + error)
                    });
                }

                const setCachedData = () => {
                    commit('setBids', ldb_user_bids);
                    success(ldb_user_bids);
                }

                if (window.history && window.history.state && window.history.state.key){
                    if (ldb_user_bids && ldb_user_bids.arg_string === arg_string) {
                        if (router.currentRoute.query.state_key && ldb_user_bids.state_key === router.currentRoute.query.state_key) {
                            setCachedData()
                        } else if (ldb_user_bids.state_key === window.history.state.key) {
                            setCachedData()
                        } else {
                            getFreshData()
                        }
                    } else {
                        getFreshData()
                    }
                } else {
                    getFreshData()
                }
            })
        });
    },
    getBidUsers({commit, state}, {params, cancelToken} = {cancelToken: axios.CancelToken.source(), params: {}}){
        return api.get('user-bid.getBidUsers', [], params)
    },
    storeBid({ commit, state }, args) {
        return new Promise((success, error) => {
            api.store('user-bid', args).then(tag => {
                success(tag);
            }).catch(error);
        });
    },
    addBidMessage({ commit, state }, args) {
        return new Promise((success, error) => {
            api.post('user-bid.addBidMessage', args.bid_id, args).then(res => {
                success(res);
            }).catch(error);
        });
    },
    sendNichiboImages({ commit, state }, bid_id) {
        return new Promise((success, error) => {
            api.post('user-bid.sendNichiboImages', bid_id, {}).then( res => {
                success(res);
            }).catch(error);
        });
    },
    addVehicleMessage({ commit, state }, args) {
        return new Promise((success, error) => {
            api.post('vehicleMessages.store', [], args).then(res => {
                success(res);
            }).catch(error);
        });
    },
    deleteBidMessage({ commit, state }, args) {
        return new Promise((success, error) => {
            api.post('user-bid.deleteBidMessage', args.bid_id, {
                bid_message_id: args.message.id
            }).then(res => {
                success(res);
            }).catch(error);
        });
    },
    cancelBid({ commit, state }, args) {
        return new Promise((success, error) => {
            api.post('user-bid.cancelBid', args.bid_id, args).then(res => {
                success(res);
            }).catch(error);
        });
    },
    changeBid({ commit, state }, args) {
        return new Promise((success, error) => {
            api.update('user-bid', args, args.id).then(res => {
                success(res);
            }).catch(error);
        });
    },
};

// mutations
const mutations = {
    setSelectedVehicles (state, value) {
        state.selected_vehicles = value
    },
    setBids (state, result) {
        let ids = [];
        if (result.data && result.data.length) {
            result.data.forEach(v => {
                ids.push(v.api_id)
            })
        }
        state.all = result.data;
        state.ids = ids;
        state.total = result.total;
        state.last_page = result.last_page;
        state.from = result.from;
        state.to = result.to;
        state.current_page = result.current_page;
        state.per_page = parseInt(result.per_page);
        saveState(state)
    },
    setFavouriteTags (state, result) {
        state.all = result;
        saveState(state)
    },
    setViewType (state, value) {
        state.viewType = value;
        saveState(state)
    },
    setPerRow (state, value) {
        state.perRow = value;
        saveState(state)
    },
    updateBidMessages(state, {bid_id, message}) {
        state.all.forEach(vehicle => {
            if (vehicle && vehicle.bids) {
                vehicle.bids.forEach(bid => {
                    if (bid.id === bid_id) {
                        if (!bid.messages) {
                            bid.messages = [];
                        }
                        if (Array.isArray(message)) {
                            message.forEach((msg) => {
                                bid.messages.push(msg);
                            })
                        } else {
                            bid.messages.push(message);
                        }
                    }
                })
            }
        });
        saveState(state)
    },
    setVehicleChecked (state, checked) {
        state.vehicleChecked = checked
        saveState(state)
    },
    setBidChecked (state, checked) {
        state.bidChecked = checked
        saveState(state)
    },
    setFilteredUsers (state, filteredUsers) {
        state.filteredUsers = filteredUsers
        saveState(state)
    },
    setIncludeCustomers (state, includeCustomers) {
        state.includeCustomers = includeCustomers
        saveState(state)
    },
    setIncludeCompanyStock (state, includeCompanyStock) {
        state.includeCompanyStock = includeCompanyStock
        saveState(state)
    },
    setIncludeRep (state, includeRep) {
        state.includeRep = includeRep
        saveState(state)
    },
    setRepFilter (state, repFilter) {
        state.repFilter = repFilter
        saveState(state)
    },
    setSearchChassis (state, chassis) {
        state.searchChassis = chassis
        saveState(state)
    },
    setSearchLot (state, lot) {
        state.searchLot = lot
        saveState(state)
    },
    setDateOption (state, dateOption) {
        state.dateOption = dateOption
        saveState(state)
    },
    setCustomDate (state, date) {
        state.customDate = date
        saveState(state)
    },
    setSortOrderBy (state, orderBy) {
        state.sortOrderBy = orderBy
        saveState(state)
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/userBids.js